var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('iframe',{attrs:{"id":_vm.id,"src":_vm.src,"width":"100%","height":"100%"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }